module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av628-f7bb509910c1409cb7059bdf8dbfd5e7.jpg";